import React, {Component} from 'react';
import classNames from 'classnames';
import {centsToPrice} from '../utils/filters';
import {Link} from 'gatsby';
import isTouchEnabled from '../utils/isTouchEnabled';

const ENTER_TIMEOUT = 100;
const LEAVE_TIMEOUT = 0;

export default class ProductCardGrid extends Component {
	constructor() {
		super();

		this.state = {
			isHovering: false,
		};
	}

	onMouseEnter = () => {
		if (this.state.isHovering || isTouchEnabled()) return;

		clearTimeout(this.leaveTimeout);

		this.enterTimeout = setTimeout(() => {
			this.setState({
				isHovering: true
			});
		}, ENTER_TIMEOUT);
	}

	onMouseLeave = () => {
		clearTimeout(this.enterTimeout);

		this.leaveTimeout = setTimeout(() => {
			this.setState({
				isHovering: false
			});
		}, LEAVE_TIMEOUT);
	}

	render() {
		const {
			slug = '',
			title = '',
			mainImage,
			brand = [],
			cents = 0,
			compareAtCents = 0,
			onClickQuickAdd,
			largePrice,
			noBackground,
		} = this.props;

		const {
			isHovering
		} = this.state;

		return (
			<div
				onMouseEnter={this.onMouseEnter}
				onMouseLeave={this.onMouseLeave}
				className={classNames('db product-card--grid', {
					active: isHovering
				})}>
				<Link
					className="db"
					to={`/products/${slug}`}>
					<span
						className={classNames('db product-card__bg', {
							'bg--gray-bg': !noBackground,
						})}>
						<span className="db image size--1x1 multiply">
							<picture>
								<img
									alt={title}
									src={mainImage ? `${mainImage}?w=600&h=600&auto=format` : '/images/icon-default-product-image.svg'}
								/>
							</picture>
						</span>
					</span>
					<span className="db product-card__info pt2 pb2 pl3 pr3 tc">
						{brand.length ? (
							<span className="db uppercase fw--600 product-card__brand">
								{brand.join(', ')}
							</span>
						) : null}
						<span className="db product-card__title fw--500 color--gray-text mb2">
							{title}
						</span>
						<span
							className={classNames('db', {
								'domaine--small': !largePrice,
								'domaine--medium': largePrice,
							})}>
							{compareAtCents ? (
								<span className="mr1 o50 strike">
									{centsToPrice(compareAtCents)}
								</span>
							) : null}
							{centsToPrice(cents)}
						</span>
					</span>
				</Link>
				<div className="product-card__footer">
					<button
						title="Quick Shop"
						name="add"
						onClick={onClickQuickAdd}
						className="full-width button--primary-black">
						Quick Shop
					</button>
				</div>
			</div>
		);
	}
}